import { useState } from "react";
import { useNavigate } from "react-router";
import TextInputFloat from "../../common/components/textInput/TextInputFloat";
import Logo from "../../common/components/Logo";
import login_Service from "../../../api/services/login_Service";
import { playSong } from "../../common/actions/common.actions";
import { useDispatch, useSelector } from "react-redux";
import { selectLoginData } from "../login/login.actions";
import Modal from "../../common/components/modal";
import { IoIosArrowBack } from "react-icons/io";
import { useTranslation } from "react-i18next";

const ChangePassword = ({ setIsLoading }) => {
  const dispatch = useDispatch();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [message, setMessage] = useState("Change Password Success");
  const navigate = useNavigate();
  const { userDetails } = useSelector(selectLoginData);
  const { t } = useTranslation();

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (oldPassword && newPassword && confirmPassword) {
      if (newPassword === confirmPassword) {
        try {
          setIsLoading(true);
          await login_Service.changePassword({
            userId: Number(userDetails.userId),
            CurrentPassword: oldPassword,
            NewPassword: newPassword,
            ConfirmPassword: confirmPassword,
          });
          setIsSuccess(true);
          setMessage("Password changed successfully!");
        } catch (error) {
          setIsSuccess(false);
          setMessage("Change password failed!");
          console.error("API error:", error);
        } finally {
          setIsLoading(false);
          setIsModalOpen(true);
          setOldPassword("");
          setNewPassword("");
          setConfirmPassword("");
        }
      } else {
        setIsSuccess(false);
        setMessage("New and confirm password must match.");
        setIsModalOpen(true);
      }
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    if (isSuccess) navigate("/dashboard");
  };

  const handleBackClick = () => {
    dispatch(playSong());
    navigate("/setting");
  };

  return (
    <div className="flex flex-col w-full h-full items-center justify-start  bg-white  font-dangrek">
      {/* Header */}
      <div className="w-full flex items-center mb-6 py-3 border-b border-slate-400 bg-gradient-to-r from-gradient_start to-gradient_end">
        <button
          className="text-gray-900 hover:text-gray-800 dark:text-white  dark:hover:text-blue-300"
          onClick={handleBackClick}
        >
          <IoIosArrowBack size={28} />
        </button>
        <h2 className="text-lg ml-3 font-semibold text-gray-700 dark:text-white">
          {t("changePassword")}
        </h2>
      </div>
      <div className="flex flex-col items-center justify-center  w-full h-full ">
        {/* Logo */}
        <Logo />

        {/* Card */}
        <div className="w-[75%] max-w-md mt-6 p-6 rounded-2xl bg-slate-300 dark:bg-gray-700/30 shadow-lg backdrop-blur-md border border-white/20 dark:border-white/10">
          <form onSubmit={handleChangePassword} className="space-y-6">
            <TextInputFloat
              id="oldPassword"
              placeholder="Old Password"
              type="password"
              value={oldPassword}
              setValue={setOldPassword}
            />
            <TextInputFloat
              id="newPassword"
              placeholder="New Password"
              type="password"
              value={newPassword}
              setValue={setNewPassword}
            />
            <TextInputFloat
              id="confirmPassword"
              placeholder="Confirm Password"
              type="password"
              value={confirmPassword}
              setValue={setConfirmPassword}
            />

            <button
              type="submit"
              className="w-full py-3 mt-4 text-white font-bold bg-gradient-to-r from-gradient_start to-gradient_end hover:from-gradient_start/50 hover:to-gradient_end/50 transition rounded-xl shadow-md hover:shadow-lg"
            >
              Confirm
            </button>
          </form>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <Modal title="Money Ball" content={message} onClose={closeModal} />
      )}
    </div>
  );
};

export default ChangePassword;
